<footer id="luv-footer">
    <div class="master-grid">
        <div class="t-row">
            <div class="col c--12">
                <div class="footer-in ai-center">
                    <p class="sign">Made with <span class="secondary">&hearts;</span> in Comoro Islands</p>

                    <div class="social-icons">
                        <span>Follow me on</span>
                        <a href="https://facebook.com/linkhousni" target="_blank"><i class="fab fa-facebook"></i></a>
                        <a href="https://twitter.com/linkhousni" target="_blank"><i class="fab fa-twitter"></i></a>
                        <a href="https://linkedin.com/in/linkhousni" target="_blank"><i class="fab fa-linkedin"></i></a>
                        <a href="https://github.com/linkhousni" target="_blank"><i class="fab fa-github"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>